import React, { FC, PropsWithChildren } from "react";

import {
	InfoMessage,
	IPageHeaderProps,
	PageHeader,
} from "@amphore-dev/amphore-lib";

import { cn } from "@/utils";

interface IPageLayoutProps extends PropsWithChildren, IPageHeaderProps {
	error?: string | boolean;
	isLoading?: boolean;
	wrapperClassName?: string;
	className?: string;
	sidePanel?: React.ReactNode;
	scrollable?: boolean;
	header?: React.ReactNode | false;
}

export const PageLayout: FC<IPageLayoutProps> = ({
	title,
	isLoading = false,
	error = false,
	children,
	wrapperClassName,
	className,
	sidePanel,
	scrollable = true,
	header,
	...pageHeaderProps
}) => {
	return (
		<div
			className={cn([
				"flex flex-col gap-4 p-4 md:p-6",
				!scrollable && "h-full overflow-hidden",
				wrapperClassName,
			])}
		>
			{header !== false && (
				<PageHeader
					title={title}
					isLoading={isLoading}
					{...pageHeaderProps}
				/>
			)}
			{!isLoading && !!error && (
				<InfoMessage color="danger">
					{typeof error === "string"
						? error
						: "An error occurred while loading the page."}
				</InfoMessage>
			)}

			{!isLoading && !error && (
				<div
					className={cn([
						"page-content",
						!scrollable && "overflow-hidden",
						className,
					])}
				>
					{children}
				</div>
			)}
			{!isLoading && !error && sidePanel && (
				<div className="page-side-panel">{sidePanel}</div>
			)}
		</div>
	);
};
